import { Table } from "antd";
import Column from "antd/lib/table/Column";
import React from "react";

import intl from "../../../../utils/intl";
import { Agreement } from "../../Agreement";
import messages from "./messages";
import AgreementValidationTableProps from "./props";

const AgreementValidationTable: React.FC<AgreementValidationTableProps> = (
  props: AgreementValidationTableProps
) => {
  return (
    <Table
      dataSource={props.agreements}
      rowKey={(r) => `${r.supplierId}_${r.cardIssuerId}`}
      rowClassName={(record) => (record.isDeleted ? "table-row-delete" : "")}
      pagination={{
        pageSize: 5,
      }}
    >
      <Column
        title={intl.formatMessage(messages.cardIssuerIdTitle)}
        render={(record: Agreement): React.ReactNode => record.cardIssuerId}
        width="40%"
      />
      <Column
        title={intl.formatMessage(messages.supplierIdTitle)}
        render={(record: Agreement): React.ReactNode => record.supplierId}
        width="40%"
      />
      <Column
        title={intl.formatMessage(messages.deletedTitle)}
        render={(record: Agreement): React.ReactNode =>
          record.isDeleted
            ? intl.formatMessage(messages.deletedStateYesTitle)
            : intl.formatMessage(messages.deletedStateNoTitle)
        }
        width="20%"
      />
    </Table>
  );
};

export default AgreementValidationTable;
